import styled from 'styled-components'
import { CSS } from 'ui/helpers'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  padding-bottom: 32px;

  &.hoverDisabled {
    .result-item {
      pointer-events: none;
    }
  }

  .disable-hover,
  .disable-hover * {
    pointer-events: none !important;
  }
`

const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid ${(p) => p.theme.uiKit.colors.global.grey.grey300};
`

const SectionTitle = styled.h2`
  ${(p) => CSS.populateFont(p.theme.uiKit.typography.bodyL.regular)};
  color: ${(p) => p.theme.uiKit.colors.global.grey.grey700};

  box-sizing: border-box;
  padding: 12px 20px 8px 20px;
`

const ResultListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
`
export const s = {
  Container,
  SectionWrapper,
  SectionTitle,
  ResultListWrapper
}
